export enum ExtraFieldCodeEnum {
    deliveryExtraDataServices = 'deliveryExtraDataServices',
    deliveryExtraDataAddCost = 'deliveryExtraDataAddCost',
    deliveryExtraDataAddCostType = 'deliveryExtraDataAddCostType',
    deliveryExtraDataAddOrderComment = 'deliveryExtraDataAddOrderComment',
    shipmentExtraDataConsolidatedShipment = 'shipmentExtraDataConsolidatedShipment',
    shipmentExtraDataExecutor = 'shipmentExtraDataExecutor',
    cdekPackageType = 'cdekPackageType',
    cdekPackageAmount = 'cdekPackageAmount',
    orderType = 'orderType',
    senderContragentType = 'senderContragentType',
    recipientContragentType = 'recipientContragentType',
    shipmentExtraDataRequestToCourier = 'shipmentExtraDataRequestToCourier'
}
